/**
 * The grammar of a secret-scan finding's shape: what a flagged string looks
 * like without any of its characters (backend `secretShape` in
 * codeCandidateMaterializer.ts writes it). `<n> chars, <classes>, <pattern>`,
 * where the pattern is `unstructured` or at most 12 runs of `a` (lowercase),
 * `A` (uppercase), `9` (digit), `-` (a separator) and `#` (anything else),
 * each optionally counted as `{n}`.
 *
 * Three digits suffice for every count: each scan rule that records a shape
 * matches at most 512 characters.
 *
 * The backend checks a stored shape against it on read, and the Work page
 * checks again before showing one, so no producer can put text on the page.
 */
export const SECRET_SHAPE_GRAMMAR = /^\d{1,3} chars, (?:lowercase|uppercase|digits|symbols)(?:\+(?:uppercase|digits|symbols)){0,3}, (?:unstructured|(?:[aA9#-](?:\{\d{1,3}\})?){1,12})$/;
//# sourceMappingURL=secretShape.js.map